module.exports = __webpack_public_path__ + "fonts/unicons.ca6ba13.eot";